import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MapboxComponent } from './mapbox.component';
import { NgIf } from '@angular/common';

@NgModule({
  imports: [FormsModule, NgIf],
  declarations: [MapboxComponent],
  exports: [MapboxComponent],
})
export class MapboxModule {}
